import { useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import { theme } from './report-shell/tokens'

const Layout = ({ children, user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div style={{
      display: 'flex', height: '100vh',
      background: theme.bg,
    }}>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        overflow: 'hidden', minWidth: 0,
      }}>
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          user={user}
          onLogout={onLogout}
        />

        <div style={{
          flex: 1, overflowY: 'auto',
          padding: 32, // matches ReportShell `bleed` offset
        }}>
          {children}
        </div>
      </main>
    </div>
  )
}

export default Layout
